<div class="video-player-modal">
    <button
        class="video-player-modal__close"
        mat-icon-button
        (click)="dialogRef.close()"
        aria-label="Fechar vídeo">
        <mat-icon>close</mat-icon>
    </button>

    <div class="video-player-modal__content">
        <app-video-card
            [videoUrl]="data.videoUrl"
            [modalTitle]="data?.title || 'Tutorial em vídeo'"
            [openInModal]="false"
            [autoPlay]="true"
            [showControlsOnStart]="true">
        </app-video-card>
    </div>
</div>
